import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import { QRCodeSVG } from 'qrcode.react';
import { FaCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';

import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import DescriptionIcon from '@material-ui/icons/Description';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';

import DialogoPixCode from '../../components/DialogoPixCode';
import DialogDocumentData from '../DialogDocumentData';
import Modalpdf from '../Modalpdf';

import { GET_DEALER_BY_STATE } from '../../services/endpoints';

import { Chip } from '@material-ui/core';
import { AttachFile } from '@material-ui/icons';
import { useAuth } from '../../contexts/AuthContext';
import SimpleBackdrop from '../Backdrop';
import GetShowProjectData from '../GetShowProjectData';
import { Container, FielButtons } from './styles';

export default function BaseDialogShowProject({ children, ...props }) {
  const { user } = useAuth();

  const [showbackdrop, setShowbackdrop] = React.useState(false);
  const [open, setOpen] = React.useState(true);

  const [dados, setDados] = React.useState({ ...(props.dados || {}) });

  const [listConcess, setListConcess] = React.useState(null);

  const [listpendencias] = React.useState(props.dados?.pendencies || []);

  const [listarchives] = React.useState(props.dados?.documents || []);
  const [listidx, setListidx] = React.useState(3);

  const [showPDF, setShowPDF] = React.useState({ open: false, file_pdf: '' });
  const [showDocumentData, setShowDocumentData] = React.useState({
    open: false,
    data: {},
  });

  const [viewPixCode, setViewPixCode] = React.useState({
    status: false,
    id: '',
    pixCode: '',
  });

  React.useEffect(() => {
    setDados({ ...(props.dados || {}) });
    if (props.dados?.dealer?.state) {
      GET_DEALER_BY_STATE(
        props.dados.dealer.state,
        setListConcess,
        setShowbackdrop
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => props.fechar && props.fechar(), 100);
  };

  const handleCopy = () => {
    const code = dados?.pix_code || '';
    if (!code) return;
    navigator.clipboard
      .writeText(code)
      .then(() => toast.success('Código copiado com sucesso'))
      .catch(() => {});
  };

  const handlePixUpdated = (code) => {
    setDados((s) => ({ ...s, pix_code: code }));
    props.onProjectPixUpdated?.(dados.id, code);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          props.fechar();
        }}
        maxWidth="md"
        scroll="body"
        fullScreen={window.innerWidth <= 675}
        fullWidth
        style={{ zIndex: 9999 }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Container suspended={dados.suspended}>
              <header>
                <h1>Dados do Projeto</h1>
                <span>
                  Confira abaixo os dados do projeto com mais detalhes.
                </span>

                {props?.dados_edit && (
                  <div
                    className="div__listpendencias"
                    style={{ marginTop: '1rem', marginBottom: '1rem' }}
                  >
                    <div className="div__pendencias">
                      <ErrorOutlineIcon className="icone_warn" />
                      <div className="div__info" style={{ flex: 10 }}>
                        <h5>{props?.dados_edit.title}</h5>
                        <p>{props?.dados_edit.description}</p>
                      </div>
                    </div>
                  </div>
                )}

                <content>
                  <h4>Informações da Concessionária</h4>

                  <div className="div__oneRow">
                    <p>
                      <label>Estado: </label> {dados.dealer?.state}
                    </p>
                    <p>
                      <label>Concessionária: </label>
                      {listConcess?.find((c) => c.id === dados.dealer_id)?.name}
                    </p>
                  </div>

                  <h4>Informações do Cliente</h4>
                  <div className="div__oneRow">
                    {dados?.client_cpf ? (
                      <p>
                        <label>CPF: </label> {dados?.client_cpf}
                      </p>
                    ) : (
                      <p>
                        <label>CNPJ: </label> {dados?.client_cnpj}
                      </p>
                    )}
                    <p>
                      <label>Nome: </label> {dados?.client_name}
                    </p>
                  </div>

                  <GetShowProjectData dados={dados} projectType={dados?.type} />

                  {dados.comments && (
                    <>
                      <h4>Observações</h4>
                      <div className="div__oneRow" style={{ maxWidth: '100%' }}>
                        <p>{dados.comments}</p>
                      </div>
                    </>
                  )}

                  {dados?.pix_code && user?.role === 'GERENTE' && (
                    <div>
                      <h4>Pagamento: Pix do Projeto</h4>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: 10,
                        }}
                      >
                        <QRCodeSVG value={dados?.pix_code} />
                        <div>
                          <button className="button_copy" onClick={handleCopy}>
                            {dados?.pix_code?.length > 15
                              ? `${dados?.pix_code.slice(0, 15)}...`
                              : dados?.pix_code}{' '}
                            <FaCopy />
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  <h4>Pendências</h4>

                  <div className="div__listpendencias">
                    {listpendencias?.length > 0 ? (
                      listpendencias.map((pendencia) => (
                        <div key={pendencia.id} className="div__pendencias">
                          <div className="div__info" style={{ flex: 10 }}>
                            <h5>
                              {pendencia.resolved ? (
                                <CheckCircleOutlineIcon className="icone_success" />
                              ) : (
                                <ErrorOutlineIcon className="icone_warn" />
                              )}
                              {pendencia.title}{' '}
                              <span>
                                {pendencia.file ? 'Arquivo' : 'Informação'}
                              </span>
                              {pendencia.visualized_at && (
                                <span>Visualizado pelo integrador</span>
                              )}
                            </h5>
                            <p style={{ marginBottom: 5 }}>
                              {pendencia.description}
                            </p>
                            {pendencia.customer_comment && (
                              <div className="div__respost_pendence">
                                <div className="div__comment">
                                  <strong>R:</strong>{' '}
                                  {pendencia.customer_comment}
                                </div>
                              </div>
                            )}
                            {pendencia.customer_file && (
                              <>
                                <p style={{ marginBottom: 5 }}>
                                  Arquivo anexado pelo integrador
                                </p>
                                <Chip
                                  clickable
                                  component="a"
                                  href={pendencia.customer_file_url}
                                  target="_blank"
                                  icon={<AttachFile />}
                                  label={pendencia.customer_file_name}
                                />
                              </>
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="div__nada">
                        Nenhuma pendência cadastrada
                      </div>
                    )}
                  </div>

                  <br />
                  <h4>Arquivos vinculados</h4>

                  <div className="div__listArchives">
                    {listarchives?.length > 0 ? (
                      listarchives.slice(0, listidx).map((archive) => (
                        <div key={archive.id} className="div__rowArchive">
                          <div className="div__icon">
                            <DescriptionIcon />
                          </div>
                          <div className="div__data" style={{ flex: 4 }}>
                            <p>
                              <strong>Título: </strong> {archive.title}
                            </p>
                            {archive.file && (
                              <p>
                                <strong>Arquivo: </strong> {archive.file}
                              </p>
                            )}
                            <p>
                              Envio em{' '}
                              {new Date(archive.created_at).toLocaleDateString(
                                'pt-br',
                                {
                                  day: '2-digit',
                                  month: 'long',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                }
                              )}
                            </p>
                          </div>

                          <div className="div__options" style={{ flex: 2 }}>
                            {archive.is_approved && <p>Aprovado</p>}

                            <button
                              onClick={() => {
                                if (archive.file_url) {
                                  window.open(archive.file_url, '_blank');
                                } else if (archive.data) {
                                  setShowDocumentData({
                                    open: true,
                                    data: archive.data,
                                  });
                                }
                              }}
                            >
                              <VisibilityOutlinedIcon />
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="div__nada">
                        Nenhuma arquivo cadastrado
                      </div>
                    )}

                    {listarchives?.length > listidx && (
                      <div
                        className="div__viewMore"
                        onClick={() => setListidx((v) => v + 3)}
                      >
                        Ver mais
                      </div>
                    )}
                  </div>
                </content>
              </header>
            </Container>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <FielButtons>
            <button
              onClick={handleClose}
              className="btn__retornar"
              color="primary"
              style={{ minWidth: '100px' }}
            >
              Voltar
            </button>
          </FielButtons>
        </DialogActions>
      </Dialog>

      {showPDF.open && (
        <Modalpdf
          fechar={() => setShowPDF({ open: false, file_pdf: '' })}
          fileUrl={showPDF.file_pdf}
        />
      )}

      {showDocumentData.open && (
        <DialogDocumentData
          fechar={() => setShowDocumentData({ open: false, data: {} })}
          data={showDocumentData.data}
        />
      )}

      {viewPixCode.status && (
        <DialogoPixCode
          pixCode={viewPixCode.pixCode}
          handleSetViewPixCode={setViewPixCode}
          onPixUpdated={handlePixUpdated}
          id={viewPixCode.id}
          status={viewPixCode.status}
          drop={setShowbackdrop}
          fechar={() => setViewPixCode({ status: false, id: '', pixCode: '' })}
        />
      )}

      {showbackdrop && <SimpleBackdrop />}
    </div>
  );
}
